module.exports = __webpack_public_path__ + "img/yanhuo.dbf62d83.svg";